<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'PALABRACLAVE.LBL_PALABRASCLAVES' | translate}}" *ngIf="palClave">
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PALABRACLAVE.LBL_CODIGO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{palClave.codigo}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PALABRACLAVE.LBL_NOMBRE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{palClave.nombre}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{palClave.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="columnas"
                     [value]="lisPalabraClaveActividades"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.nombreActividadEconomica}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

      </p-panel>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>
